"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportLineItems = exports.exportInvoices = exports.getPDFLink = exports.MODALS_CONF = exports.getBtnText = exports.getAvailableActions = exports.ACTION_MAPPER = exports.makeXeroURL = exports.makeStripeURL = exports.useFilterMapping = exports.filterGroupDefinitions = void 0;
var end2end_1 = require("@hudled/end2end");
var CSV = __importStar(require("csv-stringify/browser/esm/sync"));
var get_1 = __importDefault(require("lodash/fp/get"));
var fieldProcessors_1 = require("utils/fieldProcessors");
var filter_1 = require("utils/filter");
var formatters_1 = require("utils/formatters");
var logging_1 = require("utils/logging");
var constants_1 = require("./constants");
var AddChargeModal_1 = __importDefault(require("./Modals/AddChargeModal"));
var MarkInvoiceAsPaid_1 = __importDefault(require("./Modals/MarkInvoiceAsPaid"));
var RefundInvoice_1 = __importDefault(require("./Modals/RefundInvoice"));
var SendInvoiceNow_1 = __importDefault(require("./Modals/SendInvoiceNow"));
var VoidInvoice_1 = __importDefault(require("./Modals/VoidInvoice"));
var searchArr = function (items) { return items.filter(function (item) { return item !== undefined; }).join('~~'); };
var searchLineItems = function (itemExtract) { return function (item) { return searchArr(item.lineItems.map(itemExtract)); }; };
var getStatusNice = function (item) {
    var fullStatus = (0, end2end_1.getFullStatus)(item);
    var fullStatusDef = constants_1.INVOICE_STATUS_MAPPER[(0, end2end_1.getFullStatus)(item)];
    if (!fullStatusDef) {
        console.warn('No fullStatusDef for', fullStatus);
        return '';
    }
    return fullStatusDef === null || fullStatusDef === void 0 ? void 0 : fullStatusDef.text;
};
var statusGroupDef = (0, filter_1.makeGroupDef)('Status', getStatusNice);
exports.filterGroupDefinitions = [statusGroupDef];
exports.useFilterMapping = (0, filter_1.makeUseFilterItems)([
    end2end_1.getInvoiceCode,
    (0, get_1.default)('rechargedCustomer.name'),
    function (item) { return (0, end2end_1.getDateNice)(item.date); },
    function (item) { return "".concat(item.total); },
    getStatusNice,
    searchLineItems(function (lI) { return lI.description; }),
    searchLineItems(function (lI) { return lI.listPrice; }),
    searchLineItems(function (lI) { return lI.discount && lI.discount > 0 ? (0, formatters_1.formatPercentPrecise)(lI.discount) : undefined; }),
    searchLineItems(function (lI) { return lI.amount; }),
    searchLineItems(function (lI) {
        var _a, _b, _c;
        return (((_a = lI.servicePeriod) === null || _a === void 0 ? void 0 : _a.start) && ((_b = lI.servicePeriod) === null || _b === void 0 ? void 0 : _b.end))
            && (0, end2end_1.getDateRange)(lI.servicePeriod.start, (_c = lI.servicePeriod) === null || _c === void 0 ? void 0 : _c.end);
    }),
], exports.filterGroupDefinitions);
var getConnectPart = function (payConn) { return (payConn === null || payConn === void 0 ? void 0 : payConn.accountId) ? "/connect/accounts/".concat(payConn === null || payConn === void 0 ? void 0 : payConn.accountId) : ''; };
var makeStripeURL = function (rechInv, isAdmin, payConn) { return rechInv.inPaymentPlatformId
    && "https://dashboard.stripe.com".concat(isAdmin ? getConnectPart(payConn) : '', "/invoices/").concat(rechInv.inPaymentPlatformId); };
exports.makeStripeURL = makeStripeURL;
var makeXeroURL = function (rechInv) { return rechInv.accPlatformId
    && "https://go.xero.com/app/invoicing/view/".concat(rechInv.accPlatformId); };
exports.makeXeroURL = makeXeroURL;
exports.ACTION_MAPPER = {
    void_inv: { btnText: 'Void invoice', btnColor: 'red', hasModal: true },
    add_charge: { btnText: 'Add charge', btnColor: 'azzurro', hasModal: true },
    mark_as_paid: { btnText: 'Mark as paid', btnColor: 'azzurro', hasModal: true },
    refund_inv: { btnText: 'Refund Invoice', btnColor: 'red', hasModal: true },
    send_now: {
        btnText: function (rechInv) { return "".concat(rechInv.rechargedCustomer.agreementStatus === 'accepted' ? 'Charge' : 'Send', " now"); },
        btnColor: 'azzurro',
        hasModal: true,
    },
};
var getAvailableActions = function (rechInv) {
    var fullStatus = (0, end2end_1.getFullStatus)(rechInv);
    if (['onHold', 'failed'].includes(fullStatus))
        return { mainAction: 'void_inv', actions: ['void_inv', 'mark_as_paid'] };
    if (['draft', 'scheduledForSending'].includes(fullStatus)) {
        return {
            mainAction: (0, end2end_1.isInvoiceChargeable)(rechInv) ? 'send_now' : undefined,
            actions: [(0, end2end_1.isInvoiceChargeable)(rechInv) && 'send_now', 'add_charge'].filter(end2end_1.notFalsy),
        };
    }
    if (['paid'].includes(fullStatus) && rechInv.stripeChargeId) {
        return { mainAction: 'refund_inv', actions: ['refund_inv'] };
    }
    return { actions: [] };
};
exports.getAvailableActions = getAvailableActions;
var getBtnText = function (action, item) {
    var actionDef = exports.ACTION_MAPPER[action];
    return actionDef && (typeof actionDef.btnText === 'string' ? actionDef.btnText : actionDef.btnText(item));
};
exports.getBtnText = getBtnText;
exports.MODALS_CONF = {
    void_inv: VoidInvoice_1.default,
    send_now: SendInvoiceNow_1.default,
    add_charge: AddChargeModal_1.default,
    mark_as_paid: MarkInvoiceAsPaid_1.default,
    refund_inv: RefundInvoice_1.default,
};
var getPDFLink = function (invoice) { return Date.now() - invoice.date.toMillis() <= 30 * end2end_1.MS_PER_DAY ? invoice.stripeInvoicePdfUrl : undefined; };
exports.getPDFLink = getPDFLink;
var getTooltipStatus = function (item) {
    var _a;
    var tooltip = constants_1.INVOICE_STATUS_MAPPER[item.status].tooltip;
    if (typeof tooltip === 'function') {
        var title = tooltip(item).title;
        return title;
    }
    return (_a = tooltip === null || tooltip === void 0 ? void 0 : tooltip.title) !== null && _a !== void 0 ? _a : getStatusNice(item);
};
var INVOICES_HEADERS = ['invoiceNumber', 'customer', 'billingDate', 'dueDate', 'lineItemsCount', 'subTotal', 'taxAmount', 'amount',
    'currency', 'taxName', 'vendors', 'status', 'paidOn', 'failedOn', 'voidedOn'];
var INVOICES_MAPPER = {
    invoiceNumber: end2end_1.getInvoiceCode,
    customer: function (item) { var _a; return (_a = item.rechargedCustomer) === null || _a === void 0 ? void 0 : _a.name; },
    billingDate: function (item) { return (0, end2end_1.getISODate)(item.date); },
    lineItemsCount: function (item) { return item.lineItems.length; },
    subTotal: function (item) { return (0, end2end_1.roundToCents)(item.subTotal); },
    taxAmount: function (item) { return (0, end2end_1.roundToCents)(item.taxAmount); },
    amount: function (item) { return (0, end2end_1.roundToCents)(item.total); },
    vendors: function (item) { var _a; return (_a = item === null || item === void 0 ? void 0 : item.vendors) === null || _a === void 0 ? void 0 : _a.map(function (v) { return v; }).join(', '); },
    status: getTooltipStatus,
    paidOn: function (item) { var _a, _b; return ((_a = item.statusTransitions) === null || _a === void 0 ? void 0 : _a.paidAt) && ((_b = item.statusTransitions) === null || _b === void 0 ? void 0 : _b.paidAt.toDate().toISOString()); },
    failedOn: function (item) { var _a, _b; return ((_a = item.statusTransitions) === null || _a === void 0 ? void 0 : _a.failedAt) && ((_b = item.statusTransitions) === null || _b === void 0 ? void 0 : _b.failedAt[0].toDate().toISOString()); },
    voidedOn: function (item) { var _a, _b; return ((_a = item.statusTransitions) === null || _a === void 0 ? void 0 : _a.voidedAt) && ((_b = item.statusTransitions) === null || _b === void 0 ? void 0 : _b.voidedAt.toDate().toISOString()); },
};
var exportInvoices = function (items, fileName) {
    var rows = items.map((0, fieldProcessors_1.makeCsvRowGenerator)(INVOICES_HEADERS, INVOICES_MAPPER, true));
    try {
        (0, fieldProcessors_1.saveAsCSV)(CSV.stringify(__spreadArray([INVOICES_HEADERS.map(formatters_1.camelToProper)], __read(rows), false)), fileName);
    }
    catch (e) {
        (0, logging_1.logError)(e);
    }
};
exports.exportInvoices = exportInvoices;
var LINE_ITEMS_HEADERS = ['lineItem', 'invoiceNumber', 'description', 'date', 'listPrice', 'discount', 'taxAmount', 'amount',
    'taxName'];
var LINE_ITEMS_MAPPER = {
    lineItem: function (item) { return "".concat(item.invoiceNumber, "-").concat(item.position); },
    date: function (item) {
        var _a, _b, _c;
        return ((_a = item.servicePeriod) === null || _a === void 0 ? void 0 : _a.start) && ((_b = item.servicePeriod) === null || _b === void 0 ? void 0 : _b.end)
            && (0, end2end_1.getDateRange)(item.servicePeriod.start, (_c = item.servicePeriod) === null || _c === void 0 ? void 0 : _c.end);
    },
    listPrice: function (item) { return item.discount && item.discount < 0 ? '' : (0, end2end_1.roundToCents)(item.listPrice); },
    discount: function (item) { return item.discount ? item.discount > 0 && (0, formatters_1.formatPercentPrecise)(item.discount) : ''; },
    taxAmount: function (item) { return (0, end2end_1.roundToCents)(item.taxAmount); },
    amount: function (item) { return (0, end2end_1.roundToCents)(item.amount); },
};
var exportLineItems = function (items, fileName) {
    var rows = items.map((0, fieldProcessors_1.makeCsvRowGenerator)(LINE_ITEMS_HEADERS, LINE_ITEMS_MAPPER, true));
    try {
        (0, fieldProcessors_1.saveAsCSV)(CSV.stringify(__spreadArray([LINE_ITEMS_HEADERS.map(formatters_1.camelToProper)], __read(rows), false)), fileName);
    }
    catch (e) {
        (0, logging_1.logError)(e);
    }
};
exports.exportLineItems = exportLineItems;
